import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            {/* <p className="home-about-body">
              Hi, I'm Yash Bari! 🎉
              <br />
              <br />
              I love coding and have become super skilled in the MERN stack. I’ve led many IT projects, making systems 30% more efficient and boosting team productivity with smart project management. 🚀
              I am fluent in classics like
              <i>
                <b className="purple"> C++, Javascript and Go. </b>
              </i>
              <br />
              <br />
              My interests include creating new &nbsp;
               
              <i>
                <b className="purple">Web Technologies and Products </b>
              </i>
              <br />
              <br />
              Whenever I can, I love building stuff
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern JavaScript frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js. 💻</b>
              </i>
            </p> */}
            <p className="home-about-body">
  Hi! I’m <b className="purple">Yash Bari</b>, a passionate Full Stack & MERN Stack Developer with a knack for building scalable, high-performance web applications and leading IT projects that boost efficiency and productivity.
  <br /><br />
  I’ve gained solid experience crafting powerful systems using <b className="purple">Node.js</b>, <b className="purple">React.js</b>, <b className="purple">Next.js</b>, <b className="purple">PostgreSQL</b>, and <b className="purple">MongoDB</b>, among other tools. Over the years, I’ve improved backend performance by up to 70%, enhanced user engagement by 85%, and driven team productivity through smart project management.
  <br /><br />
  I’m fluent in <i><b className="purple">JavaScript</b></i> and love diving deep into modern JavaScript frameworks and web technologies to create innovative products.
  <br /><br />
  Whether it’s developing real-time chat apps, logistics platforms, or personal finance apps, I’m driven by a passion to deliver impactful, efficient, and user-friendly solutions.
  <br /><br />
  I’m also a strong believer in continuous learning and staying up-to-date with the latest trends and best practices in the tech industry. This helps me ensure that the products I build are not only functional but also future-proof and maintainable.
  <br /><br />
  Collaboration and communication are key to my approach—I enjoy working with cross-functional teams to turn ideas into reality while maintaining a clean and scalable codebase.
  <br /><br />
  Outside of coding, I’m fascinated by cloud computing, DevOps practices, and how automation can streamline workflows to maximize productivity.
  <br /><br />
  If you want someone who can combine technical excellence with strategic leadership and a love for building cool stuff, I’m your guy!
</p>


          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Yashbari01"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://twitter.com/Soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li> */}
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/yash-bari-143467216/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://www.instagram.com/soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
